var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlankSlateImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 437,
    height: 131,
    viewBox: "0 0 437 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 109.5H107.012",
    stroke: "#DAE0E5",
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.787 88.2433C167.787 88.2433 155.957 84.4104 146.905 86.4497C137.853 88.489 134.766 95.6826 134.766 95.6826C134.766 95.6826 126.139 97.2662 119.271 100.647C112.403 104.029 107 109.353 107 109.353C107 109.353 108.707 102.086 113.624 97.3405C118.541 92.5947 126.765 90.2767 126.765 90.2767C126.765 90.2767 134.774 78.7794 144.895 76.5456C155.017 74.3118 167.787 81.2236 167.787 81.2236",
    fill: "#EFF2F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.033 109.51C107.033 109.51 111.045 94.6418 127.096 90.8606",
    stroke: "#DAE0E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M178.398 98.6712C178.398 98.6712 174.134 86.9644 169.693 83.4833C154.79 71.8 137.053 74.9904 127.012 90.9192",
    stroke: "#DAE0E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M436.5 76.5H329.988",
    stroke: "#DAE0E5",
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.213 55.2433C269.213 55.2433 281.043 51.4104 290.095 53.4497C299.147 55.489 302.234 62.6826 302.234 62.6826C302.234 62.6826 310.861 64.2662 317.729 67.6474C324.597 71.0286 330 76.3532 330 76.3532C330 76.3532 328.293 69.0862 323.376 64.3405C318.459 59.5947 310.235 57.2767 310.235 57.2767C310.235 57.2767 302.226 45.7794 292.105 43.5456C281.983 41.3118 269.213 48.2236 269.213 48.2236",
    fill: "#EFF2F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M329.967 76.5096C329.967 76.5096 325.955 61.6418 309.904 57.8606",
    stroke: "#DAE0E5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M258.602 65.6712C258.602 65.6712 262.866 53.9644 267.307 50.4833C282.21 38.8 299.947 41.9904 309.988 57.9192",
    stroke: "#DAE0E5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M168.516 104.636L168.877 103.922L168.516 104.636L217.037 129.193C217.718 129.537 218.523 129.537 219.204 129.193L267.725 104.636C268.532 104.227 269.041 103.399 269.041 102.494V41.6787C269.041 40.8296 268.593 40.0438 267.861 39.6121L219.341 10.9622C218.588 10.5177 217.653 10.5177 216.9 10.9622L168.38 39.6121C167.649 40.0438 167.2 40.8296 167.2 41.6787V102.494C167.2 103.399 167.709 104.227 168.516 104.636Z",
    fill: "white",
    stroke: "#DAE0E5",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.307 11.6511C217.809 11.3548 218.432 11.3548 218.934 11.6511L268.241 40.7653L218.851 66.1161C218.393 66.3515 217.849 66.3515 217.39 66.1161L168 40.7653L217.307 11.6511Z",
    fill: "#EFF2F5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.973 66.2927V5.50334C189.973 3.40537 191.218 1.70463 192.764 1.70463H244.263C245.804 1.70463 247.054 3.3951 247.054 5.50334V66.2927",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.973 51.7336V4.64706C189.973 3.022 191.218 1.70463 192.764 1.70463H244.263C245.804 1.70463 247.054 3.01405 247.054 4.64706V51.7336",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M189.973 51.7336V4.64706C189.973 3.022 191.218 1.70463 192.764 1.70463H244.263C245.804 1.70463 247.054 3.01405 247.054 4.64706V51.7336",
    stroke: "#DAE0E5",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M168 40.4595L218 66.528V129.542",
    stroke: "#DAE0E5",
    strokeWidth: 1.6
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M268 40.4595L218 66.528V129.542",
    stroke: "#DAE0E5",
    strokeWidth: 1.6
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M199.421 34.8224H236.212",
    stroke: "#EFF2F5",
    strokeWidth: 1.28,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M198.02 43.278H209.767",
    stroke: "#DAE0E5",
    strokeWidth: 1.28,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M214.729 43.278H226.476",
    stroke: "#EFF2F5",
    strokeWidth: 1.28,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M230.037 43.278H236.225",
    stroke: "#EFF2F5",
    strokeWidth: 1.28,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M223.951 24.9575H236.207",
    stroke: "#DAE0E5",
    strokeWidth: 1.28,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M199.419 24.9575H216.941",
    stroke: "#EFF2F5",
    strokeWidth: 1.28,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M211.957 53.1429H231.738",
    stroke: "#DAE0E5",
    strokeWidth: 1.28,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M199.419 53.1429H204.193",
    stroke: "#EFF2F5",
    strokeWidth: 1.28,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M199.428 16.5019H227.852",
    stroke: "#DAE0E5",
    strokeWidth: 1.28,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M231.441 16.5019H236.214",
    stroke: "#EFF2F5",
    strokeWidth: 1.28,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankSlateImage);
export default __webpack_public_path__ + "static/media/BlankSlateImage.3d9809ffb89de2f6c115668efdf8687c.svg";
export { ForwardRef as ReactComponent };